import { render, staticRenderFns } from "./DAT.vue?vue&type=template&id=ce81e64a&"
import script from "./DAT.vue?vue&type=script&lang=js&"
export * from "./DAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports